<template>
  <div class='check-in-status'>
    <h3 class="mt-3 headline">Your items are</h3>
    <v-divider></v-divider>
    <ul class="checklist">
      <CheckInStatusItem
        v-for='status in statuses'
        :key='status.id'
        :status='status'
        :buy-status='buyStatus'/>
    </ul>
  </div>
</template>

<script>
import CheckInStatusItem from './CheckInStatusItem'
export default {
  props: ['buy'],
  data () {
    return {
      statuses: [
        {id: 0, type: 'checkedin', name: 'Checked in'},
        {id: 1, type: 'queued', name: 'Queued'},
        {id: 2, type: 'sorting', name: 'Sorting'},
        {id: 3, type: 'complete', name: 'Complete'}
      ]
    }
  },
  computed: {
    buyStatus () {
      let status = this.statuses[0]

      if (this.buy.checked_in) {
        status = this.statuses[1]

        if (this.buy.sorter_id) {
          status = this.statuses[2]

          if (this.buy.completed_at) {
            status = this.statuses[3]
          }
        }
      }
      return status
    }
  },
  components: { CheckInStatusItem }
}
</script>

<style scoped>

  ul.checklist {
    font-size: 2em;
    line-height: 2em;
    counter-reset: step;
    list-style-type: none;
    margin: 0;
    margin-top: 1em;
    padding: 0;
  }

  hr {
    background-color: #aaa;
  }
</style>



// WEBPACK FOOTER //
// src/components/CheckInStatus.vue